import { isNonEmpty } from '@sgme/fp';
import { secondaryProductsApiConnector } from 'apiConnector/secondary-market/product-search/searchProductsByCode';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, filter, mergeMap } from 'rxjs/operators';
import {
  secondaryMarketProductCodeSearchRequested,
  secondaryMarketProductsSearchedCodesFetchingFailed,
} from 'state/secondaryMarket/productSearch';
import type { EpicWithThunk } from 'state/state.common';
import { extractHttpErrorMessage, type HttpClientError } from 'utils/http/httpClient.model';

export function loadSearchedCodes(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    const { loadRecentSearchKeys } = secondaryProductsApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_PRODUCT_SEARCHED_CODES_FETCHING'),
      mergeMap(() =>
        loadRecentSearchKeys().pipe(
          filter(({ keys, dlpKeys }) => isNonEmpty(keys) || isNonEmpty(dlpKeys)),
          mergeMap(({ keys, dlpKeys }) => {
            return of(secondaryMarketProductCodeSearchRequested(keys, dlpKeys, true));
          }),
          catchError((err: HttpClientError) =>
            of(secondaryMarketProductsSearchedCodesFetchingFailed(extractHttpErrorMessage(err))),
          ),
        ),
      ),
    );
  };
}
